<template>
  <BaseSmartGateAutocompleteSelect
    :warehouse-id="warehouseId"
    :field-label="fieldLabel"
    :field-name="fieldName"
    :placeholder="placeholder"
    test-id="comet-asset-license-plate-field"
    custom-item-test-id="comet-use-custom-license-plate"
    custom-item-class="add-custom-license-plate"
    :data-mapper="licensePlateMapper"
    :rules="rules"
    :model-value="modelValue"
    @update:model-value="$emit('update:model-value', $event)" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

import BaseSmartGateAutocompleteSelect from './BaseSmartGateAutocompleteSelect.vue';

export default defineComponent({
  components: {
    BaseSmartGateAutocompleteSelect
  },
  props: {
    warehouseId: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  emits: ['update:model-value'],
  setup() {
    const { t } = useI18n();
    const fieldLabel = computed(() => t('smartGate.licenseFieldLabel'));
    const fieldName = computed(() => t('smartGate.licenseFieldName'));
    const placeholder = computed(() => t('smartGate.licensePlaceholder'));

    const licensePlateMapper = item => {
      if (item.licensePlate && item.licensePlate !== '') {
        return {
          name: item.licensePlate
        };
      }
    };

    return {
      licensePlateMapper,
      fieldLabel,
      fieldName,
      placeholder
    };
  }
});
</script>
